import React, { Component } from 'react'
import {
  getAuthManagerInstance,
  logOff,
} from '../../../global/authentication/authentication-manager.js'
import { getAbsolutePath } from '../../../global/environments/path.js'
import { sanitizeUrl } from '../../../global/formatters/sanitize-url.js'

class AuthenticatedDropdownAdvisor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: null,
      expanded: false,
    }
  }

  componentDidMount() {
    getAuthManagerInstance()
      .getProfileServiceBehaviorSubject()
      .subscribe((profile) => {
        if (profile) {
          this.setState({ user: profile })
        }
      })
  }

  onButtonClick = () => {
    this.setState({ expanded: !this.state.expanded })
  }

  logOff = () => {
    logOff()

    this.setState({
      user: null,
      expanded: false,
    })
  }

  render() {
    return this.state.user ? (
      <div
        className={`u-hidden u-sm-block CtiDropdown ${
          this.state.expanded ? 'is-expanded' : ''
        }`}
      >
        <button
          onClick={this.onButtonClick}
          className="CtiDropdown-toggle Button u-textTruncate u-padding2gu u-paddingRight4gu u-textSizeMsrp1 u-textSecondary u-textColorBrand u-flex u-flexJustifyCenter u-flexAlignItemsCenter"
          type="button"
          id="secondary-dropdown"
          aria-haspopup={this.state.expanded}
          aria-expanded={this.state.expanded}
        >
          {this.state.user.preferredFirstNm}
        </button>
        <ul
          className="CtiDropdown-menu u-bgColorWhite u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft u-borderRight u-posAbsolute u-paddingBottom1gu"
          aria-labelledby="secondary-dropdown"
        >
          <li className="u-textSizeMsrp1 u-textSecondary CtiDropdown-item">
            <a
              className="CtiDropdown-link u-block u-padding2gu u-textNoWrap"
              href="/my-profile/"
            >
              My Profile
            </a>
          </li>
          <li className="u-textSizeMsrp1 u-textSecondary CtiDropdown-item">
            <a
              className="CtiDropdown-link u-block u-padding2gu u-textNoWrap"
              href="/subscribe"
            >
              Email Subscriptions
            </a>
          </li>
          <li className="u-textSizeMsrp1 u-textSecondary CtiDropdown-item">
            <a
              onClick={this.logOff}
              className="CtiDropdown-link u-block u-padding2gu logout-button u-textNoWrap"
              href="/login?logout=true"
              data-qa-automation="advisor-log-out"
            >
              Log Out
            </a>
          </li>
        </ul>
      </div>
    ) : (
      <li className="UtilityNavigation-listItem u-hidden u-sm-inlineBlock u-marginLeft1gu">
        <a
          className="UtilityNavigation-action u-textNoWrap Button Button--secondary"
          href={sanitizeUrl(`${getAbsolutePath(true)}/login`)}
        >
          Log In
        </a>
      </li>
    )
  }
}

export default AuthenticatedDropdownAdvisor
